import React, { useState } from "react";
import { Button, Checkbox, DatePicker, Form, Image, Input, Layout, message, notification, Radio, Select, Typography } from "antd";
import HeaderComponent from "../component/header";
import { API_URL } from "../constant";

const { Option } = Select;
const { Title } = Typography;
const { Link } = Typography;
const { Header } = Layout;

const ShortRenewalPage: React.FC = () => {
  const [form] = Form.useForm();


  const onSubmit = () => {
    console.log("Form submitted");  
  };

  const onFinishFailed = (errorInfo: any) => {
    alert("Please check the form fields and try again.");
  };

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = `${API_URL}online-quotation-inquiry/images/renewalshort.pdf`;
    link.download = "filename.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div>
      <HeaderComponent />
      <div className='mt-10 max-w-screen-xl mx-auto p-20'>

        <div className='flex flex-col mb-10'>
          <Title level={2} className="flex justify-center">POLICY RENEWAL: INSURED REPRESENTATION STATEMENT</Title>
          <p className="text-center">
            Review the following data carefully to be sure that the information is accurate. Please make any needed changes or corrections directly on this page.
          </p>
        </div>

        <Form
          form={form}
          layout="horizontal"
          onFinish={onSubmit}
          onFinishFailed={onFinishFailed}
        >
          <div className='mb-5 grid grid-cols-2 sm:grid-cols-6 gap-2'>

            <div className='col-span-2 sm:col-span-6 lg:col-span-6'>
              <Form.Item label="Insured Name" name="insured_name" rules={[{ required: true }]}>
                <Input placeholder="Please enter your Insured Name" />
              </Form.Item>
            </div>

            <div className='col-span-2 sm:col-span-6 lg:col-span-3'>
              <Form.Item label="Practice address" name="practice_address" rules={[{ required: true }]}>
                <Input placeholder="Please enter your Practice address" />
              </Form.Item>
            </div>
            <div className='col-span-2 sm:col-span-2 lg:col-span-2'>
              <Form.Item label="City" name="practice_city" rules={[{ required: true }]}>
                <Input placeholder="City" />
              </Form.Item>
            </div>
            <div className='col-span-2 sm:col-span-2 lg:col-span-1'>
              <Form.Item label="ZIP Code" name="practice_zip_code" rules={[{ required: true }, { pattern: /^\d{5}(-\d{4})?$/, message: 'Use XXXXX or XXXXX-XXXX format please' }]}>
                <Input placeholder="ZIP code" />
              </Form.Item>
            </div>
            <div className='col-span-2 sm:col-span-6 lg:col-span-6'>
              <Form.Item label="Legal Entity" name="legal_entity" rules={[{ required: true }]}>
                <Input placeholder="Please enter your Legal Entity" />
              </Form.Item>
            </div>
            <div className='col-span-1 sm:col-span-3'>
              <Form.Item label="Office Phone" name="office_phone" rules={[{ required: true }, { pattern: /^\d{3}-\d{3}-\d{4}$/, message: 'Use XXX-XXX-XXXX format please' }]}>
                <Input placeholder="Please enter your Office Phone" />
              </Form.Item>
            </div>
            <div className='col-span-1 sm:col-span-3'>
              <Form.Item label="Cell Phone" name="cell_phone" rules={[{ required: true }, { pattern: /^\d{3}-\d{3}-\d{4}$/, message: 'Use XXX-XXX-XXXX format please' }]}>
                <Input placeholder="Please enter your Cell Phone" />
              </Form.Item>
            </div>
          </div>
          <div className='flex flex-col'>
            <Title level={4} className="italic text-center">
              IMPORTANT: If you are unable to initial & sign below due to changes in your practice or status, please provide a detailed explanation below or on a separate sheet.
              <br></br>
              Include all pertinent documentation 
            </Title>
            <p className="text-lg">
              I understand that: (1) my renewal policy is issued based upon reliance of the following representations; and,
              (2) any policy obtained by fraud, material misrepresentation or omission is null and void. 
            </p>
            <p className="text-lg">
              In consideration of renewal of my policy, since my ChiroFutures malpractice policy was issued last year:
            </p>
          </div>

          <div className="flex justify-center">
            <table style={{ border: "solid 1px black", width: "95%" }}>
                <tr className="h-24" style={{ border: "solid 1px black"}}>
                    <td className ="mt-2 ml-6" style={{ border: "solid 1px black", width: "80%" }}>
                        <div className="mt-2 ml-6 text-2sm">
                            1. There have been NO changes within my practice (i.e., formed new legal entity, added a new chiropractor, changed practice tools/procedures,
                            number of hours worked, OR now sharing space with/allowing another Health Care Professional to use my office, etc.) 
                        </div>
                    </td>
                    <td className="flex flex-col text-center items-center">
                        <div className="flex justify-center mt-3 text-xs">
                            Please initial
                        </div>
                        
                        <div className="flex justify-center mt-2 text-xs w-[60%]">
                            <Form.Item
                                name="initial1"
                                rules={[
                                    { required: true, message: "Please enter your initials" },
                                    { max: 4, message: "Initials should be 2–4 characters" },
                                ]}
                                className="mb-0"
                                >
                                <Input
                                    maxLength={4}
                                    style={{ textTransform: "uppercase" }}
                                />
                            </Form.Item>
                        </div>
                    </td>
                </tr> 
                <tr  className="h-24" style={{ border: "solid 1px black"}}>
                    <td className ="mt-2 ml-6" style={{ border: "solid 1px black", width: "80%" }}>
                        <div className="mt-2 ml-6 text-2sm">
                            2. I have had NO interaction with any Chiropractic Board other than my routine license renewal. This would include any board inquiries, complaints filed,
                            license investigations (closed, open or pending), and/or received a letter of concern/warning, stipulation, probation, and/or suspension. 
                        </div>
                    </td>
                    <td className="flex flex-col text-center items-center">
                        <div className="flex justify-center mt-3 text-xs">
                            Please initial
                        </div>
                        <div className="flex justify-center mt-2 text-xs w-[60%]">
                            <Form.Item
                                name="initial2"
                                rules={[
                                    { required: true, message: "Please enter your initials" },
                                    { max: 4, message: "Initials should be 2–4 characters" },
                                ]}
                                className="mb-0"
                                >
                                <Input
                                    maxLength={4}
                                    style={{ textTransform: "uppercase" }}
                                />
                            </Form.Item>
                        </div>
                    </td>
                </tr> 
                <tr  className="h-24" style={{ border: "solid 1px black"}}>
                    <td className ="mt-2 ml-6" style={{ border: "solid 1px black", width: "80%" }}>
                        <div className="mt-2 ml-6 text-2sm">
                            3. I have NOT been convicted of, plead guilty or no contest to a crime (including DUI/major traffic violation), or any other violation of a law or ordinance. 
                        </div>
                    </td>
                    <td className="flex flex-col text-center items-center">
                        <div className="flex justify-center mt-3 text-xs">
                            Please initial
                        </div>
                        <div className="flex justify-center mt-2 text-xs w-[60%]">
                            <Form.Item
                                name="initial3"
                                rules={[
                                    { required: true, message: "Please enter your initials" },
                                    { max: 4, message: "Initials should be 2–4 characters" },
                                ]}
                                className="mb-0"
                                >
                                <Input
                                    maxLength={4}
                                    style={{ textTransform: "uppercase" }}
                                />
                            </Form.Item>
                        </div>
                    </td>
                </tr> 
                <tr  className="h-24" style={{ border: "solid 1px black"}}>
                    <td className ="mt-2 ml-6" style={{ border: "solid 1px black", width: "80%" }}>
                        <div className="mt-2 ml-6 text-2sm">
                            4. Other than those previously reported, I am NOT aware of any claims, incidents, wrongful acts, licensure or accreditation actions open, closed or pending against me. 
                        </div>
                    </td>
                    <td className="flex flex-col text-center items-center">
                        <div className="flex justify-center mt-3 text-xs">
                            Please initial
                        </div>
                        <div className="flex justify-center mt-2 text-xs w-[60%]">
                            <Form.Item
                                name="initial4"
                                rules={[
                                    { required: true, message: "Please enter your initials" },
                                    { max: 4, message: "Initials should be 2–4 characters" },
                                ]}
                                className="mb-0"
                                >
                                <Input
                                    maxLength={4}
                                    style={{ textTransform: "uppercase" }}
                                />
                            </Form.Item>
                        </div>
                    </td>
                </tr> 
            </table>
          </div>
          <div className="flex mt-6">
            <Title level={5}>
              ***Attach: Proof of Coverage for all other Chiropractors & health care providers in the office.***
            </Title>
          </div>

          <div className='grid grid-cols-1 gap-4 mt-4'>
            <div className='col-span-1'>
              <p>To the best of my knowledge and belief, the representations set forth herein are true and complete. </p>
            </div>
            <div className='col-span-1'>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Button type="primary" htmlType="submit">Submit</Button>
              </div>
            </div>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default ShortRenewalPage;